import React from "react";
import { Box, Card, Typography } from "@mui/material";
import styles from "./cisoDashboard.module.scss";

export const PreventionSuccess = () => {
  return (
    <Card
      className={styles.card}
      sx={{ width: "100%" }}
      variant="outlined"
      elevation={0}
    >
      <Typography className={styles.sectionHeading} fontWeight={600}>
        Prevention Success Rate
      </Typography>
      <Typography className={styles.subtitle}>
        Auto-containment effectiveness
      </Typography>
      <Box className={styles.circleWrap}>
        <div className={styles.circleOuter}>
          <svg className={styles.circleSvg} viewBox="0 0 200 200">
            <circle
              cx="100"
              cy="100"
              r="90"
              stroke="#E5E7EB"
              strokeWidth="14"
              fill="none"
            />
            <circle
              cx="100"
              cy="100"
              r="90"
              stroke="url(#gradient)"
              strokeWidth="14"
              fill="none"
              strokeDasharray={`${2 * Math.PI * 90 * 0.96} ${2 * Math.PI * 90}`}
              strokeLinecap="round"
            />
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#0575E6" />
                <stop offset="100%" stopColor="#14B8A6" />
              </linearGradient>
            </defs>
          </svg>
          <div className={styles.circleCenter}>
            <Typography variant="h4" fontWeight={800}>
              96%
            </Typography>
            <Typography className={styles.subtitle}>Success Rate</Typography>
          </div>
        </div>
      </Box>
      <Box className={styles.list}>
        <Box className={styles.listItem}>
          <Typography className={styles.subtitle}>
            Threats Auto-Contained
          </Typography>
          <Typography fontWeight={700}>234/244</Typography>
        </Box>
        <Box className={styles.listItem}>
          <Typography className={styles.subtitle}>
            Manual Intervention
          </Typography>
          <Typography fontWeight={700}>10</Typography>
        </Box>
        <Box className={styles.listItem}>
          <Typography className={styles.subtitle}>Avg Response Time</Typography>
          <Typography fontWeight={700} color="#10b981">
            1.2s
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default PreventionSuccess;
